module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_FB_black-775f85bad5c34cc8569a3d72cc7a3ba0.svg";